/* eslint-disable */
export default {
  callerCall: 'Chiamante',
  transferCall: 'Trasferisci',
} as const;

// @key: @#@"callerCall"@#@ @source: @#@"Caller"@#@
// @key: @#@"transferCall"@#@ @source: @#@"Transfer"@#@
